import type { NotificationsService } from "./service";
import type { AxiosRequestConfig } from "axios";
import type {
  IChangeNotificationStatusRequest,
  IDeleteNotificationRequest,
  IGetNotificationsRequest,
  IGetUnreadNotificationsRequest,
  IStreamNotificationsRequest,
  IStreamNotificationsResponse,
} from "./types";
import { BaseRepository } from "../BaseRepository";
import type { IRepositoryOptions } from "@/types/common";

export class NotificationsRepository extends BaseRepository {
  constructor(
    private readonly service: NotificationsService,
    options?: IRepositoryOptions,
  ) {
    super(options);
  }

  async getAll(p: IGetNotificationsRequest, c?: AxiosRequestConfig) {
    const res = await this.handleRequest(this.service.getAll, p, c);
    return res.data;
  }

  async getUnread(p: IGetUnreadNotificationsRequest, c?: AxiosRequestConfig) {
    const res = await this.handleRequest(this.service.getUnread, p, c);
    return res.data;
  }

  async getUnreadCount(c?: AxiosRequestConfig) {
    const res = await this.handleRequest(this.service.getUnreadCount, {}, c);
    return res.data;
  }

  async markAsRead(
    p: IChangeNotificationStatusRequest,
    c?: AxiosRequestConfig,
  ) {
    const res = await this.handleRequest(this.service.markAsRead, p, c);
    return res.data;
  }

  async markAllAsRead(c?: AxiosRequestConfig) {
    const res = await this.handleRequest(this.service.markAllAsRead, {}, c);
    return res.data;
  }

  async delete(p: IDeleteNotificationRequest, c?: AxiosRequestConfig) {
    const res = await this.handleRequest(this.service.delete, p, c);
    return res.data;
  }

  async deleteAll(c?: AxiosRequestConfig) {
    const res = await this.handleRequest(this.service.deleteAll, {}, c);
    return res.data;
  }

  stream(p: IStreamNotificationsRequest): IStreamNotificationsResponse {
    return this.service.stream(p);
  }
}
